import ENVS from 'constants/environments';
import { routes } from 'constants/general';

/*
 * Replaces are double colon params of path with value found in params
 * @param path
 * @param params
 * @returns {string}
 */
export const replacePathParams = (path, params) => {
	const keys = Object.keys(params);
	if (keys.length === 0) {
		return path;
	}

	let newPath = path;
	keys.forEach((key) => {
		newPath = newPath.replace(`:${key}`, params[key]);
	});

	// replace "(:key)" because it could be optional parameter for react-router
	newPath = newPath.replace(/\((.*)\)/g, '');

	return newPath;
};

/**
 * This will parse an array of route items and try to return a path(url).
 *
 * If the path includes parameters it will try to map the routeParams and replace all parameters
 *
 * A route parameter is recognized by a double colon sign e.g. :param :id
 *
 * @param routeItems
 */
export const createPath =
	(routeItems) =>
	(identifier, routeParams = {}, withOriginLocation = false) => {
		const routeItem = routeItems.find((item) => {
			if (item.name === identifier) {
				return true;
			}
			if (item.alias && item.alias.find((alias) => alias === identifier)) {
				console.warn(`Route aliases are not meant to be used in production, please review ${identifier}`);
				return true;
			}

			return false;
		});

		if (!routeItem) {
			throw new Error(`Route ${identifier} could not be found`);
		}

		const currentLocation = document.location.pathname;
		const finalRoute = replacePathParams(`/${routeItem.path}`, routeParams);

		const objWithOriginLocation = {
			pathname: finalRoute,
			state: {
				from: currentLocation,
			},
		};

		if (withOriginLocation) {
			return objWithOriginLocation;
		} else {
			return replacePathParams(`/${routeItem.path}`, routeParams);
		}
	};

export const getRoutePath = createPath(routes);

export const isOnProd = () => {
	const origin = document.location.origin;
	return origin === ENVS.PROD;
};

export const getCurrentNonProdEnv = () => {
	const origin = document.location.origin;
	switch (origin) {
		case ENVS.AT:
			return 'AT';
		case ENVS.ST:
			return 'ST';
		case ENVS.ST4:
			return 'ST4';
		case ENVS.PREP:
			return 'PREP';
		default:
			return 'LOCAL';
	}
};
